var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Question',{staticClass:"embedpolls",attrs:{"poll_uuid":_vm.poll,"color":_vm.color,"darkColor":_vm.darkColor}})}
var staticRenderFns = []

export { render, staticRenderFns }